'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import TrustYLogo from '@/assets/img/Trusty_logo_yellow.svg'
import UserDisplay from '@/components/authorization/UserDisplay'
import { cn } from '@/utils/tailwind/utils'

type Props = {
  className?: string
}

const Header: FC<Props> = ({ className = '' }) => {
  return (
    <header className={cn('w-full overflow-hidden bg-indigo-950 p-2 px-4 shadow-md', className)}>
      <div className="flex w-full max-w-full items-center justify-between gap-2 xl:mx-auto xl:max-w-[2000px]">
        <div className="flex shrink-0 items-end">
          <Link href="/">
            <Image className="shrink-0" src={TrustYLogo} alt="TrustY" width={150} priority={true} />
          </Link>
          <div className="-m-[2.5px] ml-4 text-lg font-bold uppercase tracking-wider text-nriched-yellow max-sm:hidden sm:text-2xl">
            Dashboard
          </div>
        </div>
        <UserDisplay className="" />
      </div>
    </header>
  )
}
export default Header
